import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { getDefaultPublicSmartAssistantAvatarPathForName } from "@sukha/shared";
interface SmartAssistantAvatarProps {
  /** Assistant display name. Null while the identity is still resolving — renders the
   * neutral initial rather than guessing a name, so no assistant is shown as another. */
  name: string | null | undefined;
  /** Icon URL from DB (e.g. UploadThing URL). When provided, used instead of name-based fallback. */
  icon?: string | null;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  /** Image fit. Use "contain" to prevent clipping of fallback Marvin/Alix avatars in tight containers. */
  objectFit?: "cover" | "contain";
  /** When true, uses smaller size for legacy Marvin/Alix fallbacks and larger size for custom uploaded images. */
  cardIcon?: boolean;
}
const sizeClasses = {
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-10 h-10",
  xl: "w-16 h-16 sm:w-20 sm:h-20",
  "2xl": "w-14 h-14 sm:w-16 sm:h-16"
};
export const SmartAssistantAvatar = t0 => {
  const $ = _c(29);
  const {
    name,
    icon,
    className,
    size: t1,
    objectFit: t2,
    cardIcon: t3
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const objectFit = t2 === undefined ? "cover" : t2;
  const cardIcon = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== icon) {
    t4 = icon?.trim();
    $[0] = icon;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const isFallback = !t4;
  let T0;
  let T1;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== cardIcon || $[3] !== className || $[4] !== icon || $[5] !== isFallback || $[6] !== name || $[7] !== objectFit || $[8] !== size) {
    const trimmedName = name?.trim();
    const src = icon?.trim() ? icon : trimmedName ? getDefaultPublicSmartAssistantAvatarPathForName(trimmedName) : undefined;
    const effectiveSize = cardIcon ? isFallback ? "lg" : "2xl" : size;
    const effectiveObjectFit = cardIcon ? isFallback ? "contain" : "cover" : objectFit;
    const scaleClass = cardIcon && !isFallback ? "scale-[0.8]" : undefined;
    T1 = Avatar;
    const t9 = sizeClasses[effectiveSize];
    if ($[15] !== className || $[16] !== scaleClass || $[17] !== t9) {
      t7 = cn(t9, scaleClass, className);
      $[15] = className;
      $[16] = scaleClass;
      $[17] = t9;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    t8 = src && <AvatarImage src={src} alt={`${trimmedName ?? ""} avatar`} className={cn("w-full h-full", effectiveObjectFit === "contain" ? "object-contain" : "object-cover")} />;
    T0 = AvatarFallback;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = cn("bg-transparent");
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    t6 = trimmedName?.charAt(0)?.toUpperCase() ?? "";
    $[2] = cardIcon;
    $[3] = className;
    $[4] = icon;
    $[5] = isFallback;
    $[6] = name;
    $[7] = objectFit;
    $[8] = size;
    $[9] = T0;
    $[10] = T1;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    T0 = $[9];
    T1 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[20] !== T0 || $[21] !== t5 || $[22] !== t6) {
    t9 = <T0 className={t5}>{t6}</T0>;
    $[20] = T0;
    $[21] = t5;
    $[22] = t6;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== T1 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <T1 className={t7}>{t8}{t9}</T1>;
    $[24] = T1;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};